import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-ad-item',
  templateUrl: './ad-item-component2.component.html',
  styleUrls: ['./ad-item-component2.component.css'],
  standalone: false,
})
export class AdItemComponent2 implements OnInit {

  //constructor(public component: Type<any>, public data: any) { }
  // constructor(public component: any, public data: any) { }

  ngOnInit(): void {
  }

}
